var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardLayout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#f8f9fa",
    rx: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20, 40)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    fill: "#ffffff",
    rx: 8,
    stroke: "#e9ecef",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 20,
    width: 130,
    height: 30,
    fill: "#e9ecef",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 60,
    width: 130,
    height: 15,
    fill: "#e9ecef",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(65, 100)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 4,
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 0,
    r: 4,
    fill: "#e9ecef"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 0,
    r: 4,
    fill: "#e9ecef"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardLayout);
export default __webpack_public_path__ + "static/media/card-layout.343ed1f8e6b35e51e8bbd7bd5584baf7.svg";
export { ForwardRef as ReactComponent };